import React from 'react'
import { css } from '@emotion/react'
import { CATEGORY_MENU } from './Literals.jsx'
import { useLinkComponent } from '../../../../../links/base/useHooks.jsx'

// カテゴリーパネル
export const CategoryPanel = ({ children, ...rest }) => (
  <div 
    {...rest} 
    css={css`
      position: absolute;
      left: calc(50% - 50vw);
      top: -18px;
      width: 100vw;
      min-height: 320px;
      height: auto;
      background: #E60012;
      z-index: 90;
      opacity: 0;
      visibility: hidden;
      pointer-events: none;
      transform: translateY(8px);
      transition: opacity .3s ease-out, visibility .3s ease-out, transform .3s ease-out;
      padding: 32px 0;
    `}
  >
    {children}
  </div>
)

// グリッドコンテナ
export const Container = ({ children }) => (
  <div 
    css={css`
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 24px 32px;
      max-width: 1120px;
      margin: 0 auto;
      padding: 0 0;
    `}
  >
    {children}
  </div>
)

// 三角形インジケーター
export const TriangleIndicator = () => (
  <div css={css`
    width: 34.64px;
    height: 30px;
    background: #F4F5F7;
    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
  `} />
)

// カテゴリーアイテム
export const CategoryItem = ({ category, onCategoryClick, isActive, categoryIndex }) => (
  <div css={css`
    display: flex;
    flex-direction: column;
    position: relative;
  `}>
    <button
      onClick={onCategoryClick}
      css={css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding: 8px 16px;
        width: 256px;
        height: 48px;
        background: #FFFFFF;
        border: none;
        cursor: pointer;
        text-decoration: none;
        transition: all 0.2s ease;
        
        &:hover {
          background: #3C3C3C;
          
          /* テキストのホバー時スタイル */
          & > span {
            color: #F4F5F7;
          }
          
          /* アイコンのホバー時スタイル */
          & > div {
            background: #F4F5F7;
          }
        }
        
        /* アクティブ状態のスタイル */
        ${isActive && `
          background: #3C3C3C;
        `}
      `}
    >
      <span css={css`
        height: 22px;
        font-style: normal;
        font-weight: 600;
        font-size: 16px;
        line-height: 22px;
        letter-spacing: 0.02em;
        color: #3C3C3C;
        flex: 1;
        text-align: left;
        white-space: nowrap;
        transition: color 0.2s ease;
        
        /* アクティブ状態のテキストカラー */
        ${isActive && `
          color: #F4F5F7;
        `}
      `}>
        {category.name}
      </span>
      <div css={css`
        width: 14px;
        height: 14px;
        min-width: 14px;
        background: #707070;
        mask-image: ${isActive 
          ? `url("data:image/svg+xml,%3Csvg width='14' height='2' viewBox='0 0 14 2' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 2V0H14V2H0Z' fill='%23F4F5F7'/%3E%3C/svg%3E")`
          : `url("data:image/svg+xml,%3Csvg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M6 7.92857H0V6.07143H6V0.5H8V6.07143H14V7.92857H8V13.5H6V7.92857Z' fill='%23707070'/%3E%3C/svg%3E")`
        };
        mask-repeat: no-repeat;
        mask-position: center;
        flex: none;
        margin-left: 16px;
        transition: background 0.2s ease;
        
        /* アクティブ状態のアイコンカラー */
        ${isActive && `
          background: #F4F5F7;
        `}
      `} />
    </button>
  </div>
)

// サブカテゴリーパネル
export const SubCategoryPanel = ({ categoryId, categoryName, categoryIndex, subCategories, categoryUrl, subCategoryUrls = {} }) => {
  const Link = useLinkComponent();

  return (
  <div css={css`
    grid-column: 1 / -1;
    width: 100%;
    margin-top: 0;
    z-index: 90;
  `}>
    <div css={css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 24px 0px 28px;
      gap: 48px;
      width: 100%;
      height: auto;
      background: #F4F5F7;
    `}
      data-category-index={categoryIndex}
    >
      {/* サブカテゴリーヘッダー */}
      <div css={css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding: 0px 0px 0px 22px;
        width: auto;
        height: 32px;
      `}>
        <Link
          to={categoryUrl}
          css={css`
            display: flex;
            flex-direction: row;
            align-items: center;
            padding: 4px 16px;
            gap: 10px;
            width: auto;
            min-width: 193px;
            height: 32px;
            background: #3C3C3C;
            white-space: nowrap;
            text-decoration: none;
            transition: all 0.2s ease;
            
            &:hover {
              background: rgba(60, 60, 60, 0.7);
            }
            
            &:active {
              background: rgba(60, 60, 60, 0.7);
            }
          `}>
          <span css={css`
            font-style: normal;
            font-weight: 600;
            font-size: 16px;
            line-height: 24px;
            letter-spacing: 0.1em;
            color: #F4F5F7;
            white-space: nowrap;
          `}>{categoryName}</span>
          <span css={css`
            font-style: normal;
            font-weight: 400;
            font-size: 12px;
            line-height: 24px;
            letter-spacing: 0.1em;
            color: #F4F5F7;
            white-space: nowrap;
          `}>{CATEGORY_MENU.SHOW_ALL_CATEGORIES}</span>
        </Link>
      </div>

      {/* サブカテゴリーリスト */}
      <div css={css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
        align-content: flex-start;
        padding: 0px 32px;
        gap: 24px 32px;
        width: 100%;
        height: auto;
      `}>
        {subCategories.map(subCategory => (
          <Link
            key={subCategory.id}
            to={subCategoryUrls[subCategory.id] || subCategory.url}
            css={css`
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              padding: 0px;
              gap: 8px;
              width: 184px;
              height: 32px;
              text-decoration: none;
            `}
          >
            <span css={css`
              font-style: normal;
              font-weight: 400;
              font-size: 15px;
              line-height: 24px;
              color: #3C3C3C;
              letter-spacing: 0.05em;
              width: 100%;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              transition: color 0.2s ease;
              
              a:hover & {
                color: rgba(60, 60, 60, 0.7);
              }
              
              a:active & {
                color: rgba(60, 60, 60, 0.7);
              }
            `} title={subCategory.name}>{subCategory.name}</span>
            <div css={css`
              width: 184px;
              height: 0px;
              border: 1px solid #707070;
            `} />
          </Link>
        ))}
      </div>
    </div>
  </div>
  );
} 